import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, concat } from 'rxjs';
import { reduce } from 'rxjs/operators'
import { DocumentService } from './document.service';
import { ModuleConfigService as ConfigService } from 'src/app/shared/services/config.service';

@Injectable({  providedIn: 'root',})// This service is available in root
export class EdmsService extends DocumentService {
  private apiUrl: string;
  private endPoint = 'edms';
  private emdsUrl: string;
  constructor(private httpClient: HttpClient,
    configService: ConfigService
  ) {
    super();
    this.apiUrl = configService.rimApiUrl + configService.rimEndPoint;
    this.emdsUrl = configService.emdsUrl;
  }

  public getQueryString(fileLocationNumber: string): Observable<string> {
    return this.httpClient.get(`${this.apiUrl}/${this.endPoint}/${fileLocationNumber}`,
      { responseType: 'text' });
  }

  public getUrl(fileLocationNumber: string): Observable<string> {
    let f = concat(of(this.emdsUrl), this.httpClient.get(`${this.apiUrl}/${this.endPoint}/${fileLocationNumber}`,
    { responseType: 'text' }));
    return f.pipe(reduce((acc, one) => acc + one));
  }

}
